import { useSelector } from 'react-redux'
import { CharacterCountIndicator, Text } from 'common-components'
import { dispatch } from 'store'
import { aiVideoThunks } from 'store/features/aiVideo/thunks'
import { aiVideoSelectors } from 'store/features/aiVideo/selectors'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import * as Styled from './styled'
import { MAX_CHARACTER_COUNT, PLACEHOLDER_TEXTS } from './consts'
import { translate } from 'utils/translations'
import { T } from 'consts/translationKeys'
import { memo, useState } from 'react'
import { useTypingPlaceholder } from './useTypingPlaceholder'
import { TextAreaInput } from 'common-components'

const TextAreaSection = () => {
  const value = useSelector(aiVideoSelectors.prompt)
  const hasMediaItems = useSelector(projectDataSelectors.hasMediaItems)
  const [isFocused, setIsFocused] = useState(false)
  const isAnimationActive = !value && !hasMediaItems && !isFocused
  const elementRef = useTypingPlaceholder(
    PLACEHOLDER_TEXTS,
    isAnimationActive,
    isFocused ? '' : translate(T.PROMPT_PLACEHOLDER)
  )

  const handleChange = (newValue: string) => {
    dispatch(aiVideoThunks.setPrompt(newValue))
  }

  const isAtLimit = !!value?.length && value.length >= MAX_CHARACTER_COUNT

  return (
    <Styled.TextAreaSection>
      <Text type="h2" fontWeight="600" color="secondaryDark">
        {translate(T.PROMPT)}
      </Text>
      <div>
        <TextAreaInput
          textAreaRef={elementRef}
          onChange={handleChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          value={value}
          minHeight={164}
          hasErrorOutline={isAtLimit}
          maxLength={MAX_CHARACTER_COUNT}
        />
        <CharacterCountIndicator
          currentTextLength={value?.length || 0}
          maxCount={MAX_CHARACTER_COUNT}
          textWarningState={isAtLimit ? 'error' : undefined}
        />
      </div>
    </Styled.TextAreaSection>
  )
}

export default memo(TextAreaSection)
